<template>
  <div>
    <v-server-table
      ref="flowServer"
      :url="env"
      :columns="columns"
      :options="options"
      class="jTable jTableRules"
      @loading="loading"
      @loaded="loaded"
      @row-click="rowClick"
      @pagination="paginationClick">

      <div
        slot="beforeFilter"
        class="custom-search">
        <b-row>
          <b-col cols="7">
            <b-form
              @keyup.enter="filter(filter_data)">
              <b-form-group>
                <j-input
                  v-model="filter_data"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col
            class="p--1 p__l--2"
            style="align-self: center;"
            cols="5">
            <b-button
              class="btn blue outline"
              @click="filter(filter_data)"> <i class="fa fa-search bold" /> Search </b-button>
          </b-col>
        </b-row>
      </div>

      <div
        slot="flow"
        slot-scope="props">
        <div
          v-for="(flow, index) in props.row.members"
          :class="{'light-blue-flow' : index % 2 === 0}"
          :key="index"
          class="flow-table flow-arrow">
          <i
            v-if="index === 0"
            class="fa fa-square"/>
          {{ flow.order }}
        </div>
      </div>

      <div
        slot="created_date"
        slot-scope="props">
        {{ props.row.created_date | moment("DD/MM/YYYY") }}
      </div>

      <div
        slot="type_name"
        slot-scope="props">
        {{ props.row.type_name }}
        {{ props.row.minimum_action !== 0 ? props.row.minimum_action : '' }}
      </div>

    </v-server-table>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import { jFlow } from '@/mixins/components/jojoflow/jFlow';

export default {
  mixins: [jFlow],
  data() {
    return {
      selected_flow_id: [],
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['flows_table']),
    ...mapState('jStoreRules', ['rules_detail']),
  },
  watch: {
    selected_flow_id(newData, oldData) {
      if (this.selected_flow_id.length === 0) {
        oldData.forEach((key) => {
          const elem = document.getElementsByClassName(`row-${key.id}`);
          if (elem.length > 0) {
            elem[0].classList.remove('selected-row');
          }
        });
      }
    },
    rules_detail(newData) {
      if (this.rules_detail) {
        this.selected_flow_id = newData.flows;
      }
    },
  },
  created() {
    // this.getListFlow();
  },
  methods: {
    ...mapActions('jStoreFlows', ['getListFlow']),
    rowClick(data) {
      const elem = document.getElementsByClassName(`row-${data.row.id}`);
      if (this.selected_flow_id[0]) {
        let selectedId = null;
        this.selected_flow_id.forEach((key, index) => {
          if (data.row.id === key.id) {
            elem[0].classList.remove('selected-row');
            this.selected_flow_id.splice(index, 1);
            selectedId = 'available';
          }
        });
        if (selectedId !== 'available') {
          elem[0].classList.add('selected-row');
          this.selected_flow_id.push(data.row);
        }
      } else {
        this.selected_flow_id.push(data.row);
        elem[0].classList.add('selected-row');
      }
      this.$emit('rowClick', this.selected_flow_id);
    },
    paginationClick() {
      // this.selected_flow_id.forEach((key) => {
      //   const elem = document.getElementsByClassName(`row-${key.id}`);
      //   if (elem.length === 0) {
      //     setTimeout(() => {
      //       elem[0].classList.add('selected-row');
      //     }, 0);
      //   }
      // });
    },
    clearRules() {
      this.selected_flow_id = [];
    },

    // loading() {
    //   if (this.load_first) {
    //     this.toggleLoading();
    //   }
    // },

    // handle bug fixing buffer
    removeRowBackground() {
      return false;
    },

    loaded() {
      this.selected_flow_id.forEach((key) => {
        const elem = document.getElementsByClassName(`row-${key.id}`);
        if (elem.length === 1) {
          elem[0].classList.add('selected-row');
        }
      });
      if (this.load_first) {
        this.toggleLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },
  },
};
</script>

<style lang="scss">
.jTableRules {
  .table-responsive {
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/flow-rule/rules/jRulesTableNew.vue